<div class="d-flex justify-content-between aling-middle">
	<div class="snb-msg">
		<span>{{data.message}}</span>
	</div>
	<span><button mat-button matSnackBarAction (click)="snackBarRef.dismissWithAction()"><i class="fa-solid fa-xmark"></i></button></span>
</div>